/// <reference path='../../typings/browser.d.ts' />
/// <reference path='../../customtypings/angular-peity/angular-peity.d.ts' />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />

namespace Application.Directives {
    'use strict';

    import TrendingInfo = Models.TrendingInfo;
    import IPlotPoint = Models.IPlotPoint;
    import ISimpleSonElement = Models.ISimpleSonElement;
    declare type GridSwitchMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                 $timeout: angular.ITimeoutService,
                                                 $location: ng.ILocationService,
                                                 streamStatusService: Services.StreamStatusService,
                                                 $q: ng.IQService,
                                                 alarmsService: Services.AlarmsService,
                                                 stompService: Services.StompService,
                                                 $cookies: ng.cookies.ICookiesService,
                                                 timezoneService: Services.TimezoneService,
                                                 flexCollectorService: Services.FlexCollectorService,
                                                 $rootScope: Services.IFlexSettings,
                                                 sonService: Services.SonAdapterService,
                                                 ) => GridSwitchMonitorDirective;

    export interface IGridSwitchMonitorScopeDef {
        model: string;
        id: string;
        showTrending: string;

    }

    interface ICriticalAlarm {
        alarmName: string;
        deviceSimplifiedHref: string;
    }

    export interface IGridSwitchMonitorScope extends ng.IScope {
        model: Models.IGridMonitor;
        id: string;
        humanReadableBits: (bits: number) => string;

        plot: jquery.flot.plot;
        loadStreamData: () => void;
        initIntervals: () => void;
        getContentStyle: () => Object;
        monitorStatus: string;
        trending: {
            outputData: Models.IBitRateTrending[];
            inputData: Models.IBitRateTrending[];
            currentBitrate: string;
        };
        streamDataTimerPromise: angular.IPromise<void>;
        monitorInfoLabel: string;
        deviceIds: string[];
        paramNameOutput: string;
        paramNameInput: string;
        hasData: () => boolean;
        showHistoricalTraffic: () => void;
        trendingInfos: TrendingInfo[];
        plotOptions: Chart.ChartOptions;
        showTrending: boolean;
        reRender: boolean;
        stompReconnectUnsubscribe: Function;
        plotSeries: IPlotPoint[][];
        lastValidPoints: IPlotPoint[];
    }

    export class GridSwitchMonitorDirective implements ng.IDirective {
        public static $name: string = 'gridSwitchMonitor';
        public static $inject: string[] = [];

        private static maxGraphSeconds: number = 90;
        private static STREAM_DATA_TIMER: number = 4000;

        public link: (scope: IGridSwitchMonitorScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/grid-switch-monitor-directive.html';
        public scope: IGridSwitchMonitorScopeDef = {
            model: '=',
            id: '=',
            showTrending: '=',
        };

        public static Factory(): GridSwitchMonitorDirectiveCb {
            let directive: GridSwitchMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                     $timeout: angular.ITimeoutService,
                                                     $location: ng.ILocationService,
                                                     streamStatusService: Services.StreamStatusService,
                                                     $q: ng.IQService,
                                                     alarmsService: Services.AlarmsService,
                                                     stompService: Services.StompService,
                                                     $cookies: ng.cookies.ICookiesService,
                                                     timezoneService: Services.TimezoneService,
                                                     flexCollectorService: Services.FlexCollectorService,
                                                     $rootScope: Services.IFlexSettings,
                                                     sonService: Services.SonAdapterService) => {
                return new GridSwitchMonitorDirective($interval,
                                                $timeout,
                                                $location,
                                                streamStatusService,
                                                $q,
                                                alarmsService,
                                                stompService,
                                                $cookies,
                                                timezoneService,
                                                flexCollectorService,
                                                $rootScope,
                                                sonService);
            };
            directive.$inject = ['$interval',
                                 '$timeout',
                                 '$location',
                                 'streamStatusService',
                                 '$q',
                                 'alarmsService',
                                 'stompService',
                                 '$cookies',
                                 'timezoneService',
                                 'flexCollectorService',
                                 '$rootScope',
                                 'sonAdapterService',
                                ];
            return directive;
        }

        constructor(private $interval: angular.IIntervalService,
                    private $timeout: angular.ITimeoutService,
                    private $location: ng.ILocationService,
                    private streamStatusService: Services.StreamStatusService,
                    private $q: ng.IQService,
                    private alarmsService: Services.AlarmsService,
                    private stompService: Services.StompService,
                    private $cookies: ng.cookies.ICookiesService,
                    private timezoneService: Services.TimezoneService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private $rootScope: Services.IFlexSettings,
                    private sonAdapterService: Services.SonAdapterService) {
            GridSwitchMonitorDirective.prototype.link = (scope: IGridSwitchMonitorScope, element: JQuery, attrs: ng.IAttributes) => {

                scope.plotOptions = {
                    layout: {
                        padding: {
                            top: 10,
                            bottom: 10,
                        },
                    },
                    elements: {
                        line: {
                            borderWidth: 4,
                            fill: false,
                        },
                        point: {
                            radius: 0,
                        },
                    },
                };
                this.initData(scope).then(() => {
                    this.initBindings(scope);
                    this.getTrendingData(scope);
                });


                scope.humanReadableBits = (bits: number): string => {
                    // incoming data is megabits
                    if (bits !== undefined) {
                        return Common.Utils.kibiHumanReadableBits(bits * 1000000);
                    } else {
                        return "No data";
                    }
                };

                scope.getContentStyle = (): Object => {
                    let container: JQuery = $('.grid-thumb-monitor-wrapper').parent();
                    let width: number = container.width();
                    let height: number = container.height();
                    let aR: number = 16 / 9;
                    let monitorWidth: number;
                    let monitorHeight: number;
                    let monitorTop: number = 0;
                    let monitorLeft: number = 0;
                    if (width / height > aR) {
                        monitorWidth = height * aR;
                        monitorHeight = height;
                        monitorLeft = (width - monitorWidth) / 2;
                    } else {
                        monitorWidth = width;
                        monitorHeight = width / aR;
                        monitorTop = (height - monitorHeight) / 2;
                    }
                    return {
                        'width': `${monitorWidth}px`,
                        'height': `${monitorHeight}px`,
                        'position': 'relative',
                        'top': `${monitorTop}px`,
                        'left': `${monitorLeft}px`,
                    };
                };

                scope.hasData = (): boolean => {
                    return scope.plotSeries && scope.plotSeries[0] !== undefined && scope.plotSeries.length > 0;
                };

                scope.showHistoricalTraffic = (): void => {
                    if (scope.model.sourceName || scope.model.sinkName) {
                        const sourcePathElement: string = scope.model.sourceName ? scope.model.sourceName : "_";
                        const sinkPathElement: string = scope.model.sinkName ? scope.model.sinkName : "_";
                        this.$location.path(`/historicalByDataPorts/${sourcePathElement}/${sinkPathElement}/bitrate`);
                    }
                };
            };
        }

        private initData(scope: IGridSwitchMonitorScope): ng.IPromise<void> {
            scope.deviceIds = [];
            const promises: ng.IPromise<void>[] = [];
            if (scope.model.source) {
                promises.push(this.sonAdapterService.getSourceByUid('' + scope.model.source).then((sonElement: ISimpleSonElement) => {
                    scope.model.sourceName = sonElement.meta.dns;
                    scope.deviceIds.push(`sonElements/${sonElement.meta.dns}`);
                }));

            }
            if (scope.model.sink) {
                promises.push(this.sonAdapterService.getDestinationByUid("" + scope.model.sink).then((sonElement: ISimpleSonElement) => {
                    scope.model.sinkName = sonElement.meta.dns;
                    scope.deviceIds.push(`sonElements/${sonElement.meta.dns}`);
                }));

            }
            // scope.paramNameOutput = `outputBitrate`;
            //  scope.paramNameInput = `inputBitrate`;
            scope.trending = {
                inputData: [],
                outputData: [],
                currentBitrate: '0 Mbps',
            };
            scope.reRender = true;
            return this.$q.all(promises).then(() => {
                return;
            });
        }

        private initBindings(scope: IGridSwitchMonitorScope): void {
            scope.stompReconnectUnsubscribe = this.$rootScope.$on('stompReconnect', () => {
                if (scope.trendingInfos) {
                    scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                        trendingInfo.closeAfterReconection();
                        trendingInfo.initTrendingData();
                    });
                } else {
                    this.getTrendingData(scope);
                }
            });

            scope.$on('$destroy', () => {
                this.$interval.cancel(scope.streamDataTimerPromise);
                this.close(scope);
            });

            this.$interval.cancel(scope.streamDataTimerPromise);
            scope.streamDataTimerPromise = this.$interval(() => {
                this.getTrendingData(scope);
            }, GridSwitchMonitorDirective.STREAM_DATA_TIMER + Common.Utils.randomNumber(600));


            scope.$watch('model', (newValue: Models.Monitor, oldValue: Models.Monitor) => {
                if (newValue !== oldValue) {
                    this.close(scope);
                    this.initData(scope).then(() => {
                        this.getTrendingData(scope, true);
                    });

                }
            });
            scope.$watch('showTrending', (newVal: boolean, oldVal: boolean) => {
                scope.showTrending = newVal;
                scope.reRender = false;
                setTimeout(() => scope.reRender = true, 0);
            });
        }

        private close(scope: Application.Directives.IGridSwitchMonitorScope): void {
            if (scope.trendingInfos) {
                scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                    trendingInfo.close();
                });
                scope.trendingInfos = undefined;
            }
            scope.stompReconnectUnsubscribe();
        }

        private getTrendingData(scope: IGridSwitchMonitorScope, forceRefresh: boolean = false): void {
            if (scope === undefined) {
                return;
            }

            if (!scope.trendingInfos) {
                scope.plotSeries = [];
                scope.lastValidPoints = [];
                scope.trendingInfos = scope.deviceIds.map((deviceId: string, index: number) => {
                    const trendingInfo: TrendingInfo = new TrendingInfo(
                        this.streamStatusService, this.flexCollectorService, this.$timeout,
                        this.$q,
                        deviceId, GridSwitchMonitorDirective.maxGraphSeconds, true,
                        () => {
                            this.updatePlotSeries(scope, index);
                         },
                        undefined,
                        18000
                    );
                    scope.plotSeries.push(undefined);
                    scope.lastValidPoints.push(undefined);
                    return trendingInfo;
                });
                scope.trendingInfos.forEach((trendingInfo: TrendingInfo) => {
                    trendingInfo.initTrendingData();
                });

            }

         }

        private updatePlotSeries(scope: IGridSwitchMonitorScope, index: number): void {
            if (scope.plotSeries[index] === undefined && scope.trendingInfos[index].plotSeries) {
                scope.plotSeries[index] = scope.trendingInfos[index].plotSeries[0];
            }
            if (scope.trendingInfos[index].lastValidPoints) {
                scope.lastValidPoints[index] = scope.trendingInfos[index].lastValidPoints[0];
            }
        }
    }
}